import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  emailTemplates: [],
  holidays: [],
  newsletters: [],
  selectedHolidayYear: null,
  unModeratedAdverts: [],
  unModeratedBidCards: [],
  unModeratedEmployerSearches: [],
  unModeratedOccupations: [],
  users: []
}

const store = {
  state,
  actions,
  getters,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/admin/index.js